import React from 'react';

import { includes, trimEnd } from 'lodash';
import { Navigate } from 'react-router-dom';
import { LoadingSpinner, useRouteLocationRef } from '../components';
import { AppContext } from '../contexts/app_context';

// eslint-disable-next-line import/prefer-default-export
export const IsLoginGuard = ({ children }: { children: React.ReactNode }) => {
  const locationRef = useRouteLocationRef();

  const { contextIsLogin, setContextRedirectFrom } = React.useContext(AppContext);

  const [isLoading, setIsLoading] = React.useState(false);
  React.useEffect(() => {
    const setRedirectFromAsync = async () => {
      setIsLoading(true);
      await setContextRedirectFrom(locationRef.current);
      setIsLoading(false);
    };

    if (
      contextIsLogin === false &&
      !includes(
        [
          '/change_phone_number',
          '/first_new_restaurant',
          '/first_profile_edit',
          '/flow_sign_out',
          '/force_change_password',
          '/pdpa_agreement',
          '/profile/change_password',
          '/sign_out',
          '/user/edit',
        ],
        trimEnd(locationRef.current.pathname, '/'),
      )
    ) {
      setRedirectFromAsync();
    }
  }, [contextIsLogin]);

  if (isLoading) {
    return <LoadingSpinner BoxProps={{ height: '100vh' }} />;
  }

  if (contextIsLogin === false) {
    return <Navigate to="/auth/sign_in" replace />;
  }
  return children;
};
